import React from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import MultiCustomSelectV2 from "@components/Common/MultiCustomSelectV2";
import FormField from "../FormField";

interface Props {
    modeOfSale: any[];
    modeOfSales: any[];
    isConsult: boolean;
    inputModeOfSale: boolean;
    isSupportEmpty: boolean;
    setResult: (val: any) => void;
    onChange: (e: any) => void;
    onDelete: () => void;
}

const SalesMethodField = React.memo(
    ({
        modeOfSale,
        modeOfSales,
        isConsult,
        inputModeOfSale,
        isSupportEmpty,
        setResult,
        onChange,
        onDelete,
    }: Props) => {
        const { t } = useTranslation();

        return (
            <FormField
                label={t("Sales method")}
                required
                disabled={isConsult}
                error={inputModeOfSale}
                errorMessage={t("Please select a mode of sale")}
            >
                <MultiCustomSelectV2
                    onDelete={onDelete}
                    setResult={setResult}
                    result={modeOfSale}
                    data={modeOfSales}
                    onChange={onChange}
                    className={classnames("mdi_inp_FRmodeOfSale", {
                        invalid__clz: inputModeOfSale,
                        "not-allowed-input__clz": isSupportEmpty,
                    })}
                    value={`${t("Select")}...`}
                    placeholder={`${t("Select")}...`}
                    name="modeOfSale"
                />
            </FormField>
        );
    }
);

SalesMethodField.displayName = "SalesMethodField";
export default SalesMethodField;
